module.exports = __webpack_public_path__ + "img/tree.916b7905.svg";